<template>
  <span
    :style="downloadpdf === false ? 'cursor: pointer' : 'cursor: not-allowed'"
    @click="downloadpdf === false ? generaPdf(cod) : null"
  >
    <v-tooltip right>
      <template v-slot:activator="{ on, attrs }">
        <v-avatar
          v-bind="attrs"
          v-on="on"
          size="30"
          class="ml-2"
          color="red darken-4"
        >
          <v-icon class="ml-0" dark v-if="downloadpdf === false" size="25">
            mdi-file-pdf-box
          </v-icon>
          <v-progress-circular
            indeterminate
            color="white"
            v-if="downloadpdf === true"
            size="15"
          ></v-progress-circular>
        </v-avatar>
      </template>
      <span>{{
        `${
          downloadpdf === false ? "Descargar Ficha Tecnica" : "Descargando..."
        }`
      }}</span>
    </v-tooltip>
  </span>
</template>

<script>
  import { mapState } from "vuex";

  export default {
    data() {
      return {
        dialog: false,
        downloadpdf: false,
      };
    },
    props: {
      datosTecnicos: Array,
      nombreLg: String,
      cod: String,
      marca: String,
      marcapdf: String,
      img: String,
      imgpdf: String,
      despieceFile: String
    },
    methods: {
      fichaContenidoPdf() {
        return this.datosTecnicos;
      },
      async generaPdf(a) {
        let data = {
          mb: this.nombreLg,
          cont: this.fichaContenidoPdf(),
          marca: this.marcapdf,
          img: this.imgpdf,
          cod: this.cod,
          file: this.despieceFile
        };

        try {
          const abortController = new AbortController();
          const { signal } = abortController;
          let xUrl = `${this.dirTemp}/pdf/ficha.php`;
          this.downloadpdf = true;
          const res = await fetch(xUrl, {
            method: "POST",
            signal,
            body: JSON.stringify(data),
            headers: {
              "Content-Type": "application/x-www-form-urlencoded",
            },
          });
          if (!res.ok) {
            const err = new Error("Error en la peticion Fetch");
            err.status = res.status || "00";
            err.statusText = res.statusText || "Ocurrio un Error";
            throw err;
          }
          const resp = await res.arrayBuffer();
          if (!signal.aborted) {
            const file = new Blob([resp], { type: "application/pdf" });
            const fileURL = URL.createObjectURL(file);
            const link = document.createElement("a");
            link.href = fileURL;
            link.download = this.cod + ".pdf";
            link.click();
          }
        } catch (e) {
          console.log("Error:", e);
        } finally {
          this.downloadpdf = false;
        }
      },
    },

    computed: {
      ...mapState(["dirTemp"]),
      fichaContenido: function () {
        return function (id) {
          return this.datosTecnicos.filter(
            (x) => x.Grupo === id && x.Valor != ""
          );
        };
      },
    },
  };
</script>

<style></style>
